import { useNavigate, useParams } from 'react-router';

import { useQueryClient } from '@tanstack/react-query';
import { FormikHelpers } from 'formik';
import { useSnackbar } from 'notistack';

import { formatInitialDadosBasicosData } from './useQueryDadosBasicos';

import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoDadosBasicos } from 'pages/compra/configuracao-pedido/types';

export function useMutateDadosBasicos() {
    const { activeStep, setActiveStepSaved, setStepDisabled } = useConfigPedidoStepContext();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const { mutate, isLoading } = useFormMutation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const onSubmit = (values: ConfigPedidoDadosBasicos, formik: FormikHelpers<ConfigPedidoDadosBasicos>): void => {
        values.idConfigPedido = Number(id);

        mutate(
            {
                formik,
                url: '/gestao/configpedido',
                idField: id ? 'idConfigPedido' : '',
                formData: values,
                preventRedirect: true,
                preventSnack: true,
            },
            {
                onSuccess: ({ data }: any) => {
                    const { idTipoControleEstoquePedido } = data.data.tipoControleEstoquePedido;
                    const { idTipoPedido } = data.data.tipoPedido;

                    enqueueSnackbar('Dados básicos salvos com sucesso', { variant: 'success' });

                    setActiveStepSaved();

                    setStepDisabled('importarEstoque', idTipoControleEstoquePedido !== 2);
                    setStepDisabled('sazonal', idTipoPedido !== 4);

                    formik.resetForm({ values: formatInitialDadosBasicosData(data.data) });

                    queryClient.invalidateQueries(['config-pedido-steps']);

                    if (!activeStep.fgSaved) {
                        setTimeout(() => {
                            navigate(`/compra/configuracao-pedido/form/${data.data.idConfigPedido}`);
                        }, 50);
                    }
                },
            },
        );
    };

    return { onSubmit, isLoading };
}
